































































import http from "@/axios/http-common";
// import { resepStore } from "@/store/modules/resep";
import { sum, map, debounce } from "lodash";
import { Vue, Component, Watch, Ref, Prop } from "vue-property-decorator";
// import ObatItemRow from "@/components/resep/ObatItemRow.vue";
import ObatRacikanRowRanap from "@/components/resep/ObatRacikanRowRanap.vue";
import ObatItemResep from "@/components/resep/ObatItemResep.vue";
import ObatSearchBox from "@/components/resep/ObatSearchBox.vue";
import { appModule } from "@/store/modules/app";
import { resepStore } from "@/store/modules/resep";

interface ObatSingle {
  type: "nrc";
  obat_nama: string;
  qty: number;
  qty_unit: string;
  // signa: string;
  harga: number;
  countedHarga: number;
  obat_id: string;
  ap_rute: string;
  ap_frekuensi: string;
  ap_dosis: string;
  ap_tambahan: string;
  ap_template_id: string;
  ap_template_nama: string;
  r: string;
  frekuensi_id: string;
  rute_id: string;
  frekuensi?: {
    id: number;
    nama: string;
  };
  rute?: {
    id: number;
    nama: string;
  };
}

interface ObatRacikan {
  type: "rc";
  obat_nama: string;
  nama: string;
  qty: number;
  qty_unit: string;
  // signa: string;
  harga: number;
  countedHarga: number;
  obat_id: string;
  ap_rute: string;
  ap_frekuensi: string;
  ap_dosis: string;
  ap_tambahan: string;
  ap_template_id: string;
  ap_template_nama: string;
  r: string;
  frekuensi_id: string;
  rute_id: string;
  sediaan_id: string;
  frekuensi?: {
    id: number;
    nama: string;
  };
  rute?: {
    id: number;
    nama: string;
  };
  sediaan?: {
    id: number;
    nama: string;
  };
  items: ItemObatRacikan[];
}

interface ItemObatRacikan {
  obat_id: string;
  obat_nama: string;
  // qty: number;
  // qty_unit: string;
  ap_dosis: string;
  r: string;
}

// interface ObatRacikan {
//   type: "racikan";
//   obat: Array<any>;
//   sediaan: string;
//   qty: string;
//   signa: string;
// }

const currencyFormatter = new Intl.NumberFormat("id-ID", {
  style: "currency",
  currency: "IDR"
});

@Component({
  components: {
    // ObatItemRow,
    ObatItemResep,
    ObatRacikanRowRanap,
    ObatSearchBox
  }
})
export default class CardResepInputItem extends Vue {
  // @Prop() resep_item: Array<ObatSingle | ObatRacikan> = [];

  @Prop() resep_item: Array<any>;
  @Prop() items: Array<ObatSingle | ObatRacikan>;
  @Prop() jenis: number;
  // public entries = [];
  // public isLoading = false;
  // public model = null;
  // public search = null;
  // public items: Array<ObatSingle | ObatRacikan> = [];
  // public items: Array<any>;
  public count = 0;
  public totalHarga = 0;
  // public _timerId;
  public addBtnLoading = false;
  resepItems = [];

  @Prop() showed: boolean;

  get sortedItems() {
    return (
      this.resepItems
        // .map(item => {
        //   // @ts-ignore
        //   item.frekuensi_id = item.frekuensi?.id
        //     ? parseInt(item.frekuensi.id)
        //     : null;
        //   // @ts-ignore
        //   item.rute_id = item.rute?.id ? parseInt(item.rute.id) : null;

        //   return item;
        // })
        .sort((a, b) => {
          if (b.type === "rc" && a.type === "nrc") {
            return -1;
          } else if (a.type === "rc" && b.type === "nrc") {
            return 1;
          }

          return 0;
        })
    );
  }

  get depoId() {
    return resepStore.depoId;
  }

  // get obatList() {
  //   return this.entries
  //     .sort((a, b) => {
  //       if (a.stock_qty === 0 && b.stock_qty !== 0) {
  //         return 1;
  //       } else if (a.stock_qty !== 0 && b.stock_qty === 0) {
  //         return -1;
  //       } else if (a.nama === b.nama) {
  //         return b.stock_qty - a.stock_qty;
  //       } else {
  //         return a.nama.localeCompare(b.nama);
  //       }
  //     })
  //     .map((it, idx) => {
  //       it["index"] = idx;
  //       return it;
  //     });
  // }

  mounted() {
    this.setInputField();
  }

  setInputField() {
    console.log("set input field...");
    this.resepItems = [...this.items];

    this.resepItems.map(item => {
      // if (!Object.hasOwnProperty.call(item, "frekuensi_id")) {
      item["frekuensi_id"] = item.frekuensi
        ? parseInt(item.frekuensi.id)
        : null;
      // }

      // if (!Object.hasOwnProperty.call(item, "rute_id")) {
      item["rute_id"] = item.rute ? parseInt(item.rute.id) : null;
      // }

      if (item.r) {
        item["sediaan_id"] = item.sediaan ? parseInt(item.sediaan.id) : null;
      }

      if (Object.hasOwnProperty.call(item, "items")) {
        item.items.map(subItem => {
          subItem.frekuensi_id = subItem.frekuensi
            ? parseInt(subItem.frekuensi.id)
            : null;
          subItem.rute_id = subItem.rute ? parseInt(subItem.rute.id) : null;

          return subItem;
        });
      }

      return item;
    });

    this.$nextTick(() => {
      this.$nextTick(() => {
        this.focusToSearch();
      });
    });

    console.log(
      "card resep input item on mounted",
      this.resepItems,
      this.items
    );
  }

  @Watch("showed")
  changedShowed(show: boolean) {
    if (show) {
      // this.$nextTick(() => {
      //   this.$nextTick(() => {
      //     this.focusToSearch();
      //   });
      // });

      this.setInputField();
    }
  }

  @Ref() readonly obatSearchBox!: ObatSearchBox;

  validateItems() {
    const fieldsQty = this.resepItems.filter(item => {
      return !item.qty;
    });

    const emptyRute = this.resepItems.filter(item => !item.rute_id);
    const freqRute = this.resepItems.filter(item => !item.frekuensi_id);

    // const fieldsSigna = this.resepItems.filter((item) => {
    //   return item.signa;
    // });

    // const obatRacikanEmpty = this.resepItems.filter((item) => {
    //   return item.type == "racikan" && item.obat.length < 1;
    // });

    // if (obatRacikanEmpty.length) {
    //   appModule.sendErrorAlert(
    //     "Mohon maaf, ada obat racikan yang komponen obatnya masih kosong"
    //   );

    //   return false;
    // }

    if (this.jenis != 2 && fieldsQty.length > 0) {
      const msg = fieldsQty
        .map(it => {
          return `${it.obat_nama} jumlah obat belum diisi.`;
        })
        .join("<br/>");

      appModule.sendErrorAlert(
        "Mohon maaf, ada isian yang belum sesuai:<br/>" + msg
      );

      return false;
    }

    if (freqRute.length > 0) {
      const msg = freqRute
        .map(it => {
          return `${it.obat_nama} frekuensi harus diisi.`;
        })
        .join("<br/>");

      appModule.sendErrorAlert(
        "Mohon maaf, ada isian yang belum sesuai:<br/>" + msg
      );

      return false;
    }

    if (emptyRute.length > 0) {
      const msg = emptyRute
        .map(it => {
          return `${it.obat_nama} rute obat harus diisi.`;
        })
        .join("<br/>");

      appModule.sendErrorAlert(
        "Mohon maaf, ada isian yang belum sesuai:<br/>" + msg
      );

      return false;
    }

    return true;
  }

  itemColor(index) {
    return index % 2 === 0 ? "grey lighten-3" : "";
  }

  focusToSearch() {
    this.obatSearchBox.focus();
  }

  handleSelectObat(val) {
    this.addObatSingle(val);
  }

  close() {
    this.clearFields();
    this.$emit("close");
  }

  clearFields() {
    // this.search = "";
    // this.entries = [];
    this.items = [];
    this.totalHarga = 0;
    this.resep_item = [];
    this.resepItems = [];
  }

  submitItems() {
    this.addBtnLoading = true;
    const print = [];

    const valid = this.validateItems();

    if (!valid) {
      this.addBtnLoading = false;
      return false;
    }

    // rencananya buat simpan signa kalo ada signa baru

    // kasih loader biar seakan2 load data
    setTimeout(() => {
      this.addBtnLoading = false;

      console.log("submitItems....", this.sortedItems);

      this.$emit("exportResepItem", this.sortedItems);
      this.close();
    }, 300);
  }

  sumTotalHarga() {
    this.totalHarga = sum(map(this.items, "countedHarga"));
  }

  formatHarga(harga) {
    return currencyFormatter.format(harga);
  }

  addObatSingle(obat = null) {
    if (obat) {
      // console.log("obat,", obat);
      this.resepItems.push({
        type: "nrc",
        obat_nama: obat.nama,
        qty: null,
        qty_unit: obat.satuan,
        // signa: "",
        harga: obat.harga,
        countedHarga: null,
        obat_id: obat.id,
        ap_rute: null,
        ap_frekuensi: null,
        ap_dosis: 1,
        ap_tambahan: null,
        ap_template_id: null,
        ap_template_nama: null,
        r: "",
        frekuensi_id: null,
        rute_id: null
      });
    } else {
      this.resepItems.push({
        type: "nrc",
        obat_nama: "",
        qty: null,
        qty_unit: "",
        // signa: "",
        harga: null,
        countedHarga: null,
        obat_id: null,
        ap_rute: null,
        ap_frekuensi: null,
        ap_dosis: 1,
        ap_tambahan: null,
        ap_template_id: null,
        ap_template_nama: null,
        r: "",
        frekuensi_id: null,
        rute_id: null
      });
    }
  }

  addObatRacikan() {
    const rc = this.resepItems
      .filter(item => item.r?.startsWith("r"))
      .sort((a, b) => a.r.localeCompare(b.r, "en", { numeric: true }));
    const lastRc = rc.length > 0 ? rc.pop() : null;
    const idx = lastRc ? parseInt(lastRc.r.replace("r", "")) + 1 : 1;

    this.resepItems.push({
      type: "rc",
      obat_nama: null,
      nama: `Racikan ${idx}`,
      qty: null,
      qty_unit: null,
      harga: null,
      countedHarga: null,
      obat_id: null,
      ap_rute: null,
      ap_frekuensi: null,
      ap_dosis: 1,
      ap_tambahan: null,
      ap_template_id: null,
      ap_template_nama: null,
      r: `r${idx}`,
      frekuensi_id: null,
      rute_id: null,
      sediaan_id: null,
      items: []
    });
  }

  removeItem(idx) {
    this.resepItems.splice(idx, 1);

    console.log("remove item from input", this.resepItems);
  }

  // showWarningModal(item) {
  //   alert("Restriksi: \r\n" + item.restriksi);
  // }

  // itemHighlightedIdx = null;

  // listItemIndexUpdated(val) {
  //   this.itemHighlightedIdx = val;
  // }
}
